import { coreTranslations } from 'translations';

const incidentManagementMenuItems = _rootMenu;

function _rootMenu() {
    return {
        i18n: coreTranslations.ng_core_incidentManagement,
        linkTitle: 'Incident Management',
        icon: 'onsolve-incident-icon',
        routeTo: '/incident-management',
        isRenderable: true,
        accessConfiguration: permissions =>
            permissions.canViewIncidentManagement() &&
            (permissions.canViewLookOut() ||
            permissions.canViewSOS() ||
            permissions.canViewLockBox() ||
            permissions.canManageInternalConferenceResponse())
    };
}

export default incidentManagementMenuItems;
